import LabelInput from 'components/Base/LabelInput';
import { useState, useEffect } from 'react';
import useStyles from './styles';
import UploadMedia from '../../../../Base/UploadMedia';
import { isString } from 'lodash';
import { toBase64 } from "helpers/common";

const Step2 = (props: any) => {
  const classes = useStyles();
  const {
    urlVideoExercise,
    setUrlVideoExercise,
    exerciseImage,
    setExerciseImage,
    itemEdit,
    thumbNail,
    setThumbnail
  } = props;
  const [urlLink, setUrlLink] = useState<any>(null);

  const onChangeLinkVideo = (e: any) => {
    setUrlLink(null);
    setExerciseImage && setExerciseImage(null, null);
    setThumbnail && setThumbnail(null);
    setUrlVideoExercise && setUrlVideoExercise(e?.target?.value);
  };

  const onChangeImageExercise = (image: any, thumbnailImage: any) => {
    setUrlVideoExercise && setUrlVideoExercise("");
    setExerciseImage && setExerciseImage(image, thumbnailImage);
  };

  const renderLinkImages = async () => {
    let rs: any = itemEdit?.image || '';
    if (exerciseImage && !isString(exerciseImage)) {
      rs = await toBase64(exerciseImage) || '';
    } else {
      rs = exerciseImage || ''
    }
    setUrlLink(rs);
    return null;
  };

  useEffect(() => {
    renderLinkImages();
  }, [itemEdit, exerciseImage]);

  const getUrlLink = () => {
    if (urlLink) {
      if (urlLink?.includes("base64")) {
        return urlLink;
      }
      return urlLink?.includes("http") ? urlLink : `${process.env.REACT_APP_STORAGE_DOMAIN}/${urlLink}`;
    }

    return null;
  }

  const getThumbnail = () => {
    if (thumbNail) {
      if (thumbNail?.includes("base64")) {
        return thumbNail;
      }
      return thumbNail?.includes("http") ? thumbNail : `${process.env.REACT_APP_STORAGE_DOMAIN}/${thumbNail}`;
    }

    return null;
  }
  return (
    <div className={classes.container}>
      <LabelInput
        label='YouTube or Vimeo URL'
        value={urlVideoExercise}
        onChange={onChangeLinkVideo}
        customClass={classes.customInput}
      />
      <p style={{ font: 'normal normal 400 16px/24px Montserrat', color: '#000' }}>or</p>
      <UploadMedia
        label=''
        mediaUrl={getUrlLink()}
        thumbNail={getThumbnail()}
        placeholder={<div className={classes.uploadContainer}>
            <div className={classes.uploadTxtHeader}>Drag or click to upload video or image</div>
            <div className={classes.uploadText}>Upload a video of a single rep, and we'll transform it into a personalized GIF where your clients will experience a seamless loop.</div>
            <div className={classes.uploadText}>Must be under 10 MB</div>
        </div>}
        onChangeImage={onChangeImageExercise}
        customClass={classes.selectAppIcon}
        onlyAcceptType={["video/mp4","image/png", "image/jpg", "image/jpeg", "image/tiff", "image/gif"]}
      />
    </div>
  );
};

export default Step2;
